var options = {
    add: false,
    addTo: 'panels'
};
export default options;
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
export function extendShorthandOptions(options) {
    if (typeof options == 'boolean') {
        options = {
            add: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    if (options.addTo == 'panels') {
        options.addTo = '.mm-listview';
    }
    return options;
}



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/dividers/_options.js
// module id = 14
// module chunks = 0